import { render } from "./NewsCard.vue?vue&type=template&id=3154193c&scoped=true"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=3154193c&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3154193c"]])

export default __exports__